require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-great-finish-to-our-inaugural-code-fellows-class.json") })
        }
      }, "path---blog-great-finish-to-our-inaugural-code-fellows-class");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-great-finish-to-our-inaugural-code-fellows-class!./.cache/json/blog-great-finish-to-our-inaugural-code-fellows-class.json
// module id = 826
// module chunks = 231608221292675